<template>
  <div class="form__container">
    <div class="form__container__content">
      <StatusHeader :data="importStatusMapped" :solvedConflicts="solvedConflicts" />
    </div>

    <StatusList
      :data="importStatusMapped"
      :solvedConflicts="solvedConflicts"
      @solvedConflicts="openDialogSolvedConflicts"
      @undoSolutions="openDialogSolvedConflicts"
      @reviewErrors="openDialogLinesWithErrors"
    />
    <!-- @undoSolutions="handleUndoSolutions" -->

    <StatusFooter
      :data="importStatusMapped"
      :payload="data"
      :solvedConflicts="solvedConflicts"
    />

    <DialogLinesWithErrors
      :visible="dialogLinesWithErrors"
      :kind="kind"
      :lines="data.errors"
      :maxLines="maxLines"
      :worksheetTarget="worksheetTarget"
      :supportedFileTypes="supportedFileTypes"
      @close="closeDialogLinesWithErrors"
      @change="handleChangeUploadBox({})"
      @success="handleSuccessUploadBox"
      @error="handleErrorUploadBox"
    />

    <DialogSolvedConflicts
      :visible="dialogSolvedConflicts"
      :data="data"
      @close="closeDialogSolvedConflicts"
      @resolvedConflicts="handleUpdateSolvedConflicts"
    />
  </div>
</template>

<script>
import uploadBox from 'mixins/uploadBox'
import StatusHeader from 'components/bulkImport/stepTwo/StatusHeader'
import StatusList from 'components/bulkImport/stepTwo/StatusList'
import StatusFooter from 'components/bulkImport/stepTwo/StatusFooter'
import DialogLinesWithErrors from 'components/bulkImport/stepTwo/DialogLinesWithErrors'
import DialogSolvedConflicts from 'components/bulkImport/stepTwo/dialogSolvedConflicts'

export default {
  name: 'StepTwo',
  components: {
    StatusHeader,
    StatusList,
    StatusFooter,
    DialogLinesWithErrors,
    DialogSolvedConflicts
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    kind: {
      type: String
    },
    maxLines: {
      type: Number
    },
    worksheetTarget: {
      type: [String, Array]
    },
    supportedFileTypes: {
      type: Array
    }
  },
  mixins: [uploadBox],
  computed: {
    importStatus () {
      const { insert, qtdErrors, updates, conflicts, total } = this.data
      return {
        success: insert,
        errors: qtdErrors,
        updates,
        conflicts,
        total
      }
    }
  },
  data () {
    return {
      solvedConflicts: 0, // TO DO
      dialogLinesWithErrors: false,
      dialogSolvedConflicts: false,
      importStatusMapped: {}
    }
  },
  methods: {
    handleUndoSolutions () {
      alert('TO DO => handleUndoSolutions')
    },

    openDialogLinesWithErrors () {
      this.dialogLinesWithErrors = true
    },

    closeDialogLinesWithErrors () {
      this.dialogLinesWithErrors = false
    },

    openDialogSolvedConflicts () {
      this.dialogSolvedConflicts = true
    },

    closeDialogSolvedConflicts () {
      this.dialogSolvedConflicts = false
    },

    handleUpdateSolvedConflicts (val = 0) {
      const solvedConflicts = this.data && this.data.data ? this.data.data : []
      const solvedConflictsArray = solvedConflicts.reduce((acc, item) => {
        if (item.status && item.status.code) acc.push(item.status.code)
        return acc
      }, [])

      this.importStatusMapped = {
        ...this.importStatus,
        solvedConflictsArray,
        success: val > 0 ? this.importStatus.success + val : this.importStatus.success,
        // errors: 0,
        // updates: 0,
        conflicts: val > 0 ? this.importStatus.conflicts - val : this.importStatus.conflicts
      }

      this.solvedConflicts = val
    }
  },
  watch: {
    data: {
      deep: true,
      handler (val) {
        this.handleUpdateSolvedConflicts(this.solvedConflicts)
      }
    }
  },
  mounted () {
    this.handleUpdateSolvedConflicts()
  }
}
</script>
